export function Footer() {
  const year = new Date().getFullYear();
  return `
    <footer class="footer text-white pt-5 pb-3">
      <div class="container">

        <div class="row">

          <!-- Brand -->
          <div class="col-md-4 mb-4">
            <h5 class="mb-3">
              <span style="color:#E50914;">Hunter</span> Cuan
            </h5>
            <p class="text-secondary small">
              Solusi Digital Kreatif untuk kebutuhan bisnis dan personal Anda.
            </p>
          </div>

          <!-- Menu -->
          <div class="col-md-4 mb-4">
            <h6 class="mb-3">Menu</h6>
            <ul class="list-unstyled">
              <li><a href="#home" class="footer-link">Home</a></li>
              <li><a href="#layanan" class="footer-link">Layanan</a></li>
              <li><a href="#harga" class="footer-link">Harga</a></li>
              <li><a href="#tentang" class="footer-link">Tentang</a></li>
            </ul>
          </div>

          <!-- Kontak -->
          <div class="col-md-4 mb-4">
            <h6 class="mb-3">Kontak</h6>
            <p class="small text-secondary mb-2">
              <i class="bi bi-whatsapp me-2"></i> +6283872687465
            </p>
            <p class="small text-secondary">
              <i class="bi bi-envelope me-2"></i> hntrcuan17@gmail.com
            </p>
          </div>

        </div>

        <hr style="border-color: rgba(255,255,255,0.1);">

        <div class="text-center small text-secondary">
          © ${year} Hunter Cuan. All rights reserved.
        </div>

      </div>
    </footer>
  `;
}
